    
  export const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date
      .toLocaleString("default", { month: "short" })
      .toUpperCase();
    const year = String(date.getFullYear()).slice(-2);
    return `${day} ${month} ${year}`;
  };

  export const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };
  
  export const capitalize = (string) => {
    if (!string) return "";

    return string
      .toLowerCase()
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const SUB_BOOKING_STATUS_LABELS = {
    BATCHPENDING: "Pending Acceptance",
    BATCHCONFIRMED: "Accepted",
    TRAVELSTARTED: "Travel Started",
    REACHEDLOCATION: "Reached Location",
    MEASUREMENTACCEPTED: "Measurement Accepted",
    WORKSTARTED: "Work Started",
    GEOIMAGEUPDATED: "Work Documented",
    // AMS-80: no payment step for a Captain; older parts ended at PAYMENTCOMPLETED.
    PAYMENTCOMPLETED: "Completed",
    BOOKINGCOMPLETED: "Completed",
    CANCELLED: "Cancelled",
    COMPLETED: "Completed",
  };

  // Friendly label for a sub-booking's `lastStatus` (new batch-flow enum,
  // plus the CANCELLED/COMPLETED values reused from the legacy enum).
  export const getSubBookingStatusLabel = (status) => {
    if (!status) return "-";
    return SUB_BOOKING_STATUS_LABELS[status] || capitalizeFirstLetter(status);
  };

  export const removeAllWhitespace = (str) => {
    return str.replace(/\s+/g, "");
  };

 export const sanitizeNumberInput = (str) => {    
    let cleaned = String(str).replace(/\s+/g, "").replace(/[^0-9.]/g, "");

    let parts = cleaned.split(".");
    let integerPart = parts[0];
    let decimalPart = parts[1];
 
    const MAX_INTEGER_DIGITS = 12; 
    const MAX_DECIMAL_DIGITS = 2; 

    if (integerPart.length > MAX_INTEGER_DIGITS) {
        integerPart = integerPart.substring(0, MAX_INTEGER_DIGITS);
    }

    if (decimalPart !== undefined) {        
        decimalPart = decimalPart.substring(0, MAX_DECIMAL_DIGITS);  
        return integerPart + "." + decimalPart;        
    } else {   
        return integerPart;
    }
};

// remove starting white space
  export const cleanInput = (value) => {  
    let cleanedValue = value.replace(/^\s+/, '');
    cleanedValue = cleanedValue.replace(/\s{2,}/g, ' ');
    
    return cleanedValue;
  };

  export const cleanWhitespace = (str) => {   
      let cleanedStr = str.trimStart();   
      cleanedStr = cleanedStr.replace(/\s+/g, ' ');     
      return cleanedStr;
  };

    export const resizeImage = (file, maxWidth,maxSize = 1024 * 1024) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();
  
      reader.onload = (event) => {
        img.src = event.target.result;
      };
  
      reader.readAsDataURL(file);
  
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
  
        let width = img.width;
        let height = img.height;
  
        if (width > maxWidth) {
          height *= maxWidth / width;
          width = maxWidth;
        }
  
        canvas.width = width;
        canvas.height = height;
  
        ctx.drawImage(img, 0, 0, width, height);
      const compressToUnder1MB = (quality) => {
        canvas.toBlob((blob) => {
          if (!blob) return reject(new Error("Failed to convert canvas to blob."));
          
          if (blob.size <= maxSize  || quality <= 0.4) {
           
            resolve(blob);
          } else {
           
            compressToUnder1MB(quality - 0.05);
          }
        }, "image/jpeg", quality);
      };
  
      compressToUnder1MB(0.9); 
    };
      img.onerror = (error) => {
        reject(new Error("Error loading image: " + error.message));
      };
    });
  };